import { createSlice } from "@reduxjs/toolkit";
import * as OrderApi from "../api/order";

const orderDetail = createSlice({
  name: "orderDetail",
  initialState: {
    loading: false,
    error: null,
    order: null,
  },
  reducers: {
    setLoading: (state) => {
      state.error = null;
      state.loading = true;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    getDetailSuccess: (state, action) => {
      state.order = action.payload;
      state.loading = false;
    },
  },
});

export const getOrderDetail = (id) => async (dispatch) => {
  try {
    dispatch(setLoading());
    const res = await OrderApi.getOrderById(id);
    dispatch(getDetailSuccess(res));
  } catch (error) {
    dispatch(setError(error));
  }
};

const { reducer, actions } = orderDetail;
export const { setLoading, setError, getDetailSuccess } = actions;
export default reducer;
